import React from 'react'

function ResumeContent() {
  const font = '"Terminal ", monospace'


  return (
    <div style={{
      marginLeft: '10%',
      marginRight: '10%',
      fontFamily: font, 
    }}>
      <h1 style={{
        textAlign: 'center'
      }}>
        Résumé
      </h1>
      <div style={{
        marginLeft: '10%',
        marginRight: '10%',
      }}>
        <h2>
        Education
      </h2>
      <div style={{
        marginLeft: '5%',
        marginRight: '5%',
      }}>
        <b>York University</b>
        <ul>
          <li>Computer Engineering (B.Eng., Special Honours)</li>
          <li>Related Courses: Software Design, Embedded Systems, Electronic Circuits and Devices, Digital Logic Design, Digital Systems Engineering, Signals and Systems (DSP).</li>
        </ul>
      </div>
      <h2>
        Skills
      </h2>
      <div style={{
        marginLeft: '5%',
        marginRight: '5%',
      }}>
        <ul>
          <li><b>Programming Languages</b></li>
          <ul>
            <li>Java</li>
            <li>C</li>
            <li>Python</li>
            <li>JavaScript</li>
            <li>MATLAB</li>
          </ul>
          <li><b>HDL</b></li>
          <ul>
            <li>SystemVerilog</li>
            <li>Verilog</li>
          </ul>
          <li><b>FPGA development with Quartus</b></li>
          <li><b>Microcontroller Development Frameworks</b></li>
          <ul>
            <li>ESP-IDF</li>
            <li>Arduino</li>
          </ul>
        </ul>
      </div>
      <h2>
        Experience
      </h2>
      <div style={{
        marginLeft: '5%',
        marginRight: '5%',
      }}>
        <b>Digital Design Engineer Intern</b>
        <br/>
        <i>Intel</i>
        <br/>
        May 2022 - present
        <ul>
          
        </ul>
      </div>
      
      </div>

    </div>
  )
}

export default ResumeContent